var CurrentUser = require("lib/account/CurrentUser");

require("layout/pending_task_notice.scss");

class PendingTaskNotice extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			pendingMessage: null, fadeOut: false
		};
	}

	render() {
		if (!this.state.pendingMessage) {
			return (<div />);
		} else {

			var outerClassName = this.state.fadeOut ? "pendingTaskNotice fadeOut" : "pendingTaskNotice";
			return (
				<div className={ outerClassName } >
					<div className="innerBanner fadeCycle">
						<p>{ this.state.pendingMessage }</p>
					</div>
				</div>
			);
		}
	}

	getPendingTask() {
		return this.state.pendingMessage;
	}

	// If pendingTask isn't provided, make a call to the server to check for it
	// otherwise, set it as the tast to display
	loadPendingTask(pendingTask) {
		if (pendingTask) {
			this.setState({ pendingMessage: pendingTask, fadeOut: false });
			this.schedulePendingCheck();

		} else if (CurrentUser.isSignedIn()) {
			var embeds = "user.pending_task";

			CurrentUser.api().getUser(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler(function(response) {
				if (response.user.pending_task) {
					this.setState({ pendingMessage: response.user.pending_task, fadeOut: false });
					this.schedulePendingCheck();
				} else {

					$(document).trigger('task-finished-loading', this.state.pendingMessage);
					this.setState({ fadeOut: true });

					setTimeout(function() {
						this.setState({ pendingMessage: null });
					}.bind(this), 2000);
				}
			}.bind(this)));
		}
	}

	// Schedules a time to check is the task has been completed
	schedulePendingCheck() {
		setTimeout(function() {
			this.loadPendingTask();
		}.bind(this), PendingTaskNotice.POLL_PENDING_TASK_RATE);
	}

	checkAddingStudents() {
		var task = this.getPendingTask();
		return !!(task && _.includes(PendingTaskNotice.ADDING_STUDENT_TASKS, task));
	}

	componentDidMount() {
		if (window.wrNotifications == undefined) {
			window.wrNotifications = {};
		}
		window.wrNotifications.loadPendingTask = this.loadPendingTask;
		window.wrNotifications.getPendingTask = this.getPendingTask;

		window.wrNotifications.checkAddingStudents = this.checkAddingStudents;
	}

	componentWillUnmount() {
		delete window.wrLoadPendingTask;
	}
};

PendingTaskNotice.POLL_PENDING_TASK_RATE = 5000;

PendingTaskNotice.UPLOADING_STUDENTS = "Uploading Students...";
PendingTaskNotice.GOOGLE_SYNC = "Syncing Google Students...";
PendingTaskNotice.CLEVER_SYNC = "Syncing Clever Students...";

PendingTaskNotice.ADDING_STUDENT_TASKS = [PendingTaskNotice.UPLOADING_STUDENTS,
	PendingTaskNotice.GOOGLE_SYNC, PendingTaskNotice.CLEVER_SYNC];

PendingTaskNotice.propTypes = StrictPropTypes({
});

module.exports = PendingTaskNotice;



// WEBPACK FOOTER //
// ./modules/components/layout/PendingTaskNotice.js